import React from 'react'
import classes from '../styles/App.module.css'

const Glow = () => {
  return (
    <div className={classes.glow}></div>
  )
}

export default Glow